import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../Utils/axiosInstance";

const baseUrl = process.env.REACT_APP_BASE_URL;

export const getActiveStatus = createAsyncThunk(
  "finalStatus/getActiveStatus",
  async ({ token }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        `${baseUrl}/checkout/sessions/${token}/status`
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err?.response?.data || err.message);
    }
  }
);

const initialState = {
  activeStatusData: undefined,
  isActiveLoading: false,
  activeStatusErrorMessage: "",
  activeStatusReason: "",
  appState: "CURRENT",
};

const extractStatusReason = (statusReason) => {
  if (statusReason && statusReason.includes(":")) {
    return statusReason.split(":").slice(1).join(":").trim();
  }
  return statusReason;
};

export const finalStatusSlice = createSlice({
  name: "finalStatus",
  initialState,
  reducers: {
    resetFinalStatusResponse: (state) => {
      state.activeStatusData = {};
      state.activeStatusErrorMessage = "";
      state.activeStatusReason = "";
      state.isActiveLoading = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getActiveStatus.pending, (state) => {
        state.isActiveLoading = true;
      })
      .addCase(getActiveStatus.fulfilled, (state, action) => {
        state.isActiveLoading = false;
        state.activeStatusData = action.payload;
        state.activeStatusReason = extractStatusReason(
          action.payload?.statusReason
        );
      })
      .addCase(getActiveStatus.rejected, (state, action) => {
        state.isActiveLoading = false;
        state.activeStatusErrorMessage = action.payload;
      });
  },
});

export const { resetFinalStatusResponse } = finalStatusSlice.actions;
export default finalStatusSlice.reducer;


